import React, { Component, Fragment } from 'react';
import { observer, inject } from 'mobx-react';
import { Row, Col, Spinner, UncontrolledCarousel } from 'reactstrap';
import { TabStrip, TabStripTab } from '@progress/kendo-react-layout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBed, faBath, faRuler, faChevronCircleLeft, faVideo, faStar } from '@fortawesome/free-solid-svg-icons'
import { LocationOnIsland} from './LocationOnIsland';
import {RequestMoreInfo} from './RequestMoreInfo';
import ReactGA from 'react-ga';

@inject("mobxStore")
@observer
export class ListingDetail extends Component {

  constructor (props) {
    super(props);

    this.state = {
        selected: 0
    }

    const { match: { params } } = props;
    this.myListingId = params.id;
    props.mobxStore.getListingDetail(params.id);
  }
  componentDidMount() {
    ReactGA.set({ page: `ListingDetail:${this.myListingId}`});
    ReactGA.pageview(`/property/${this.myListingId}`);
  }

  handleSelect = (e) => {
    this.setState({selected: e.selected})
  }

  render () {
    const { listingDetail, requestInfo } = this.props.mobxStore;
    const photos = [];
    let kmListing = false;

    if (listingDetail && photos.length === 0) {
        kmListing = listingDetail.listingAgentFullName === "Kevin Mackin";

        for (var ix = 0; ix < listingDetail.photoCount; ix++) {
            photos.push(
                {
                    src: listingDetail.photos[ix], altText: '', caption: '', header: ''
                });
        }
    }

    return (
      <div className="container detailsPhotos mb-4">
        { listingDetail && listingDetail.listingId === this.myListingId &&
            <div>
                <div style={{maxWidth: '90%', margin: '0 auto'}}>
                    <UncontrolledCarousel  items={photos} controls={true} slide={true} pause={'hover'} interval={8000}></UncontrolledCarousel>
                </div>
                <div className="mt-2" onClick={() => this.props.history.goBack()} style={{cursor: "pointer"}}><FontAwesomeIcon icon={faChevronCircleLeft} size="lg"/> BACK TO LISTINGS</div>
                <TabStrip selected={this.state.selected} onSelect={this.handleSelect} >
                    <TabStripTab title="Details">
                        <div>
                            <h6>{listingDetail.listingId}</h6>
                            <h5>{listingDetail.currentPrice}</h5>
                            <h4>{listingDetail.streetName}</h4>
                            <h5>{listingDetail.subdivisionName}</h5>
                            <Row className="mt-2" >
                                { listingDetail.propertyType !== 'Land' &&
                                    <Fragment>
                                        <Col sm="3">
                                            <h6><FontAwesomeIcon icon={faBed} size="lg"/> Beds: {listingDetail.roomCount}</h6>
                                        </Col>
                                        <Col sm="3">
                                            <h6><FontAwesomeIcon icon={faBath} size="lg"/> Baths: {listingDetail.bathroomsFull} full {listingDetail.bathroomsHalf} half</h6>
                                        </Col>
                                        <Col sm="3">
                                            <h6><FontAwesomeIcon icon={faRuler} size="lg"/> SQFT: {listingDetail.livingArea}</h6>
                                        </Col>
                                    </Fragment>
                                }
                                { listingDetail.virtualTourURLUnbranded &&
                                    <Col sm="3">
                                        <h6><a href={listingDetail.virtualTourURLUnbranded} target='_blank'><FontAwesomeIcon icon={faVideo} size="lg"/> Virtual Tour</a></h6>
                                    </Col>
                                }
                            </Row>
                            <Row className="mt-3">
                                <Col className="text-justify">
                                    {listingDetail.publicRemarks}
                                </Col>
                            </Row>

                            <h5 className="mt-3 mb-2" style={{color: '#477bb3'}}>Property Features</h5>

                            <Row>
                                <Col><div className="label">MLS #:</div> <div className="feature">{listingDetail.listingId}</div></Col>
                                <Col><div className="label">Cooling:</div> <div className="feature">{listingDetail.cooling}</div></Col>
                                <Col><div className="label">Roof Type:</div> <div className="feature">{listingDetail.roof}</div></Col>
                            </Row>
                            <Row className="mt-1">
                                <Col><div className="label">Days on Market:</div> <div className="feature">{listingDetail.daysOnMarket}</div></Col>
                                <Col><div className="label">Living Area:</div> <div className="feature">{listingDetail.livingArea}</div></Col>
                                <Col><div className="label">Levels:</div> <div className="feature">{listingDetail.levels}</div></Col>
                            </Row>
                            <Row className="mt-1">
                                <Col sm="8"><div className="label">Subdivision:</div> <div className="feature">{listingDetail.subdivisionName}</div></Col>
                                <Col sm="4"><div className="label">Garage Spaces:</div> <div className="feature">{listingDetail.garageSpaces}</div></Col>
                            </Row>
                            <Row className="mt-1">
                                <Col><div className="label">Property Type:</div> <div className="feature">{listingDetail.propertyType}</div></Col>
                                <Col><div className="label">Lot Size:</div> <div className="feature">{listingDetail.lotSizeAcres} acres</div></Col>
                                <Col><div className="label">Year Built:</div> <div className="feature">{listingDetail.yearBuilt}</div></Col>
                            </Row>
                            <Row className="mt-1">
                                <Col><div className="label">Assoc. Fee:</div> <div className="feature">{listingDetail.associationFee}</div></Col>
                                <Col><div className="label">Carport Spaces:</div> <div className="feature">{listingDetail.carportSpaces}</div></Col>
                                <Col><div className="label">Water Access:</div> <div className="feature">{listingDetail.waterAccess}</div></Col>
                            </Row>
                            <Row className="mt-1">
                                <Col sm="8"><div className="label">View:</div> <div className="feature">{listingDetail.view}</div></Col>
                                <Col sm="4"><div className="label">Water Front:</div> <div className="feature">{listingDetail.waterFrontYN}</div></Col>
                            </Row>
                            <Row className="mt-1">
                                <Col sm="8"><div className="label">Architectural:</div> <div className="feature">{listingDetail.architecturalStyle}</div></Col>
                                <Col sm="4"><div className="label">Taxes:</div> <div className="feature">{listingDetail.taxAnnualAmount}</div></Col>
                            </Row>

                            <h5 className="mt-3 mb-2" style={{color: '#477bb3'}}>Feature Descriptions</h5>
                            <Row>
                                <Col><div className="label">Interior:</div> <div className="feature">{listingDetail.interiorFeatures}</div></Col>
                                <Col><div className="label">Appliances:</div> <div className="feature">{listingDetail.appliances}</div></Col>
                                <Col><div className="label">Community:</div> <div className="feature">{listingDetail.communityFeatures}</div></Col>
                            </Row>
                            <Row className="mt-2">
                                <Col><div className="label">Lot:</div> <div className="feature">{listingDetail.lotFeatures}</div></Col>
                                <Col><div className="label">Utilities:</div> <div className="feature">{listingDetail.utilities}</div></Col>
                                <Col><div className="label">Assoc. Amenities:</div> <div className="feature">{listingDetail.associationAmenities}</div></Col>
                            </Row>
                            <Row className="mt-2">
                                <Col><div className="label">Flooring:</div> <div className="feature">{listingDetail.flooring}</div></Col>
                                <Col><div className="label">Furnished:</div> <div className="feature">{listingDetail.furnished}</div></Col>
                                <Col><div className="label">Fireplace:</div> <div className="feature">{listingDetail.fireplaceFeatures}</div></Col>
                            </Row>
                            <Row className="mt-2">
                                <Col><div className="label">Patio & Porch:</div> <div className="feature">{listingDetail.patioAndPorchFeatures}</div></Col>
                                <Col><div className="label">Laundry:</div> <div className="feature">{listingDetail.laundryFeatures}</div></Col>
                                <Col><div className="label">Exterior:</div> <div className="feature">{listingDetail.ExteriorFeatures}</div></Col>
                            </Row>
                            <Row className="mt-2">
                                <Col><div className="label">Pool:</div> <div className="feature">{listingDetail.poolFeatures}</div></Col>
                                <Col><div className="label">Security:</div> <div className="feature">{listingDetail.securityFeatures}</div></Col>
                                <Col><div className="label">Sewer:</div> <div className="feature">{listingDetail.sewer}</div></Col>
                            </Row>
                            <Row className="mt-2">
                                <Col><div className="label">Water Access:</div> <div className="feature">{listingDetail.waterAccess}</div></Col>
                                <Col><div className="label">Spa:</div> <div className="feature">{listingDetail.spaFeatures}</div></Col>
                                <Col><div className="label">Accessibility:</div> <div className="feature">{listingDetail.accessibilityFeatures}</div></Col>
                            </Row>
                            <Row className="mt-2">
                                <Col><div className="label">Water View:</div> <div className="feature">{listingDetail.waterView}</div></Col>
                                <Col><div className="label">Window:</div> <div className="feature">{listingDetail.windowFeatures}</div></Col>
                                <Col><div className="label">Water Extras:</div> <div className="feature">{listingDetail.waterExtras}</div></Col>
                            </Row>
                        </div>

                        <h5 className="mt-3 mb-2" style={{color: '#477bb3'}}>Location on the Island</h5>
                        <LocationOnIsland lat={listingDetail.lat} lng={listingDetail.lng} listingId={listingDetail.listingId}></LocationOnIsland>
                    </TabStripTab>

                    <TabStripTab title="Request More Information">
                        <div>
                           <RequestMoreInfo listingId={listingDetail.listingId} requestInfo={requestInfo} forGeneralEmail={false}></RequestMoreInfo>
                        </div>
                    </TabStripTab>
                </TabStrip>
                { !kmListing &&
                    <div>
                        <img className="d-inline pr-2" src="/images/house_br_logo.gif" width="120px" alt="BR"/>
                        <span>Listed by {listingDetail.listOfficeName}</span>
                    </div>
                }
                { kmListing &&
                    <p className="font-weight-bold mt-2"><FontAwesomeIcon icon={faStar} size="lg" style={{color: "gold"}}/> Another Kevin Mackin Listing</p>
                }
            </div>
        }
        { (!listingDetail || listingDetail.listingId !== this.myListingId) &&
            <Spinner size="lg"/>
        }

      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ListingDetail.jsx